var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.noSubscription && _vm.freePlan && !_vm.isBacker
    ? _c(
        "div",
        { staticClass: "text-center" },
        [
          _c(
            "site-link",
            {
              staticClass: "button primary",
              attrs: { to: { name: _vm.routerLinkName } },
            },
            [
              _vm._v("\n    Start for Free\n    "),
              _c("font-awesome-icon", {
                staticClass: "margin-left-sm",
                attrs: { icon: _vm.$v7.solid.faRocketLaunch, size: "lg" },
              }),
            ],
            1
          ),
        ],
        1
      )
    : _vm.isReactivation && "Free" !== _vm.planName
    ? _c(
        "div",
        { staticClass: "text-center" },
        [
          _c(
            "site-link",
            {
              staticClass: "button accent",
              attrs: { to: { name: _vm.routerLinkName } },
            },
            [
              _c("font-awesome-icon", {
                staticClass: "margin-right-sm",
                attrs: { icon: _vm.$v7.solid.faRocketLaunch, size: "lg" },
              }),
              _vm._v("\n    Get a New Plan!\n  "),
            ],
            1
          ),
        ],
        1
      )
    : _vm.noSubscription && _vm.isBacker
    ? _c(
        "div",
        { staticClass: "text-center" },
        [
          _c(
            "site-link",
            {
              staticClass: "button accent",
              attrs: { to: { name: _vm.routerLinkName } },
            },
            [
              _vm._v("\n    Start a Subscription\n    "),
              _c("font-awesome-icon", {
                staticClass: "margin-left-sm",
                attrs: { icon: _vm.$v7.solid.faRedo, size: "lg" },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("p", [_vm._v("and continue using services!")]),
        ],
        1
      )
    : _vm.noSubscription && _vm.paidPlan
    ? _c(
        "div",
        { staticClass: "text-center" },
        [
          _c(
            "site-link",
            {
              staticClass: "button",
              attrs: { to: { name: _vm.routerLinkName } },
            },
            [
              _vm._v("\n    Get More with " + _vm._s(_vm.planName) + "\n    "),
              _c("font-awesome-icon", {
                staticClass: "margin-left-sm",
                attrs: { icon: _vm.$v7.solid.faRocketLaunch, size: "lg" },
              }),
            ],
            1
          ),
        ],
        1
      )
    : _vm.upgradeFromFreeToPro
    ? _c(
        "div",
        { staticClass: "text-center" },
        [
          _c(
            "site-link",
            {
              staticClass: "button",
              attrs: { to: { name: _vm.routerLinkName } },
            },
            [
              _vm._v("\n    Upgrade to a Pro Plan\n    "),
              _c("font-awesome-icon", {
                staticClass: "margin-left-sm",
                attrs: { icon: _vm.$v7.solid.faArrowUp, size: "lg" },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("p", [_vm._v("to get more icons, styles, and services!")]),
        ],
        1
      )
    : _vm.isUpgrade && !_vm.isLegacySubscription
    ? _c(
        "div",
        { staticClass: "text-center" },
        [
          _c(
            "site-link",
            {
              staticClass: "button",
              attrs: { to: { name: _vm.routerLinkName } },
            },
            [
              _vm._v("\n    Upgrade to This Plan\n    "),
              _c("font-awesome-icon", {
                staticClass: "margin-left-sm",
                attrs: { icon: _vm.$v7.solid.faArrowUp, size: "lg" },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("p", [_vm._v("to get more icons, styles, and services!")]),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }